import { usePathname } from "next/navigation";
import { isDashboardAppearanceRoute } from "@/lib/utils/theme-scope";
import { useDashboardTheme } from "./DashboardThemeProvider";
import { getDashboardTheme } from "./theme";

/**
 * Hook to get mode-aware theme tokens
 * Usage: const theme = useDashboardThemeTokens();
 */
export const useDashboardThemeTokens = () => {
  const pathname = usePathname();
  const {
    mode,
    colorPalette,
    previewPalette,
    customColor,
    previewCustomColor,
    gradientEnabled,
    previewGradientEnabled,
    fontSize,
    previewFontSize,
    effectiveDashboardAppearance,
  } = useDashboardTheme();
  const activePalette = previewPalette || colorPalette;
  const activeCustomColor =
    previewCustomColor || (activePalette === "custom" ? customColor : null);
  const activeGradientEnabled =
    previewGradientEnabled !== null ? previewGradientEnabled : gradientEnabled;
  const activeFontSize = previewFontSize || fontSize;
  const appearance = isDashboardAppearanceRoute(pathname)
    ? effectiveDashboardAppearance
    : "modern";

  return getDashboardTheme(
    mode,
    activePalette,
    activeCustomColor,
    activeGradientEnabled,
    activeFontSize,
    appearance,
  );
};
